<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisMeteorological',
  routeInfo: {
    label: '气象分析',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/index.vue